import React from "react";
import CRMFieldGroup from "./CRMFields";
import { CRM_INTEGRATION_LABELS, CRMIntegration } from "./crmIntegrationTypes";

interface CRMIntegrationCardProps {
	integration: CRMIntegration;
	/** Keys this integration loaded from the server holding, which must not be edited. */
	lockedKeys: readonly string[];
	position: number;
	expanded: boolean;
	/** Validation message for this card, or null when it is valid. */
	issue: string | null;
	onToggleExpand: () => void;
	onChange: (next: CRMIntegration) => void;
	onRemove: () => void;
}

const CRMIntegrationCard: React.FC<CRMIntegrationCardProps> = ({
	integration,
	lockedKeys,
	position,
	expanded,
	issue,
	onToggleExpand,
	onChange,
	onRemove,
}) => (
	<div className="p-4 bg-white rounded-lg border border-gray-200 space-y-4">
		<div className="flex justify-between items-center">
			<div className="flex items-center space-x-2">
				<button
					type="button"
					onClick={onToggleExpand}
					className="p-1 hover:bg-gray-100 rounded"
					aria-label={expanded ? "Collapse" : "Expand"}
				>
					<img
						src={expanded ? "/assets/ui/chevron-down.svg" : "/assets/ui/chevron-right.svg"}
						width="16"
						height="16"
						alt={expanded ? "Collapse" : "Expand"}
					/>
				</button>
				<div className="text-gray-700 text-sm font-medium">
					{CRM_INTEGRATION_LABELS[integration.type]} #{position}
				</div>
				{!integration.enabled && <span className="text-xs text-gray-500">(disabled)</span>}
				{!expanded && issue && (
					<span className="text-xs text-red-600 bg-red-50 border border-red-200 rounded px-1.5 py-0.5">
						Needs attention
					</span>
				)}
			</div>
			<div className="flex items-center space-x-4">
				<label className="flex items-center space-x-2 cursor-pointer">
					<input
						type="checkbox"
						checked={integration.enabled}
						onChange={(e) => onChange({ ...integration, enabled: e.target.checked })}
						className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
					/>
					<span className="text-sm text-gray-700">Enabled</span>
				</label>
				<button type="button" onClick={onRemove} className="px-2 py-1 text-sm text-red-600 hover:bg-red-50 rounded">
					Remove
				</button>
			</div>
		</div>

		{expanded && (
			<div className={`space-y-4 ${integration.enabled ? "" : "opacity-60"}`}>
				<CRMFieldGroup integration={integration} lockedKeys={lockedKeys} onChange={onChange} />
				{issue && <div className="text-sm text-red-600">{issue}</div>}
			</div>
		)}
	</div>
);

export default CRMIntegrationCard;
